export interface Notification {
  notificationid: string;
  type: string;
  message: string;
  updated_at: string;
}

export interface NotificationsData {
  notifications: Notification[];
}

export enum NotificationType {
  DA = 'Driver Auth',
  OS = 'Over Speeding',
  HA = 'Harsh Acceleration',
  HB = 'Harsh Braking',
  MD = 'Mobile Detection',
  MDD = 'Missing Driver Detection',
}
